// extracted by mini-css-extract-plugin
module.exports = {"button":"idt-changegroupbuttons_button__27zhq"};